import { render } from "./Companypriceetc.vue?vue&type=template&id=fadbfde0&scoped=true"
import script from "./Companypriceetc.vue?vue&type=script&lang=js"
export * from "./Companypriceetc.vue?vue&type=script&lang=js"

import "./Companypriceetc.vue?vue&type=style&index=0&id=fadbfde0&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fadbfde0"]])

export default __exports__